/**
 * Lightweight metadata shared by screens that link to the bundled demo.
 *
 * Keep the screenplay itself in mockData.ts so opening the dashboard does not
 * pull the large demo document into the workspace bundle. The companion test
 * locks sceneCount to MOCK_SCENE_DATA.length so this summary cannot silently
 * drift when the demo screenplay changes.
 */
export const DEMO_PROJECT_METADATA = {
    id: 'demo',
    title: 'The Last Horizon',
    type: 'Feature Film',
    description: 'A sci-fi demo script — explore the full editor experience with pre-loaded scenes, breakdown, and scheduling.',
    thumbnailUrl: '/demo-assets/scifi_mars_colony.webp',
    sceneCount: 25,
} as const;
